import { apiUrl } from '@/api/helper';
import { useAuthStore } from '@/stores/auth/auth.slice';
import { io, Socket } from 'socket.io-client';
import { reactive, ref, watch } from 'vue';

const socketRealtime = ref<Socket | null>(null);

export const useSocket = () => {
  const socketState = reactive({
    nsp: {
      realtime: {
        connected: false,
      },
    },
  });
  const authStore = useAuthStore();

  const realtimeNSP = apiUrl('');
  realtimeNSP.pathname = 'realtime';

  watch(
    [() => authStore.tokens?.accessToken, () => authStore.connectStatus],
    ([accessToken, connectStatus]) => {
      if (socketRealtime.value) {
        socketRealtime.value.disconnect();
        socketRealtime.value = null;
      }
      if (connectStatus === 'connected' && accessToken) {
        socketRealtime.value = io(realtimeNSP.toString(), {
          auth: { authorization: `Bearer ${accessToken}` },
          transports: ['websocket'],
        });

        socketRealtime.value.on('connect', () => {
          socketState.nsp.realtime.connected = true;
        });

        socketRealtime.value.on('disconnect', () => {
          socketState.nsp.realtime.connected = false;
        });
      }
    },
    { immediate: true },
  );

  // socketNoctifications alias kept for backward-compat with App.vue bindings
  return {
    socketState,
    socketOrders: socketRealtime,
    socketNoctifications: socketRealtime,
  };
};
